<template>
<div>
  	<!-- page wrapper start -->
	<div class="pg-wrapper fav-product-list">
    <app-header></app-header>
		<main class="content-wrapper">

			<div class="columns mr0">
				<div class="column is-9-widescreen is-9-desktop is-7-tablet is-12-mobile has-background-white pr0">
					<div class="pg-title-block mb50">
						<div class="is-flex align-items-center">
              <button @click="goBack()" class="button is-flex nav-back is-rotated-180 mr20 align-items-center">
                <img src="@/assets/img/icon-nav-arrow-right.svg" alt="Go Back">
              </button>
							<div class="title-block is-flex flex-1 justify-content-between align-items-center">
								<h1 class="title mb0">Product Details</h1>
                <a href="#" @click.prevent="isFavProduct ? unFavouriteProduct() : favouriteProduct()" :class="isFavProduct ? 'mr20 fav-product' : 'mr20'"><img src="@/assets/img/icon-favourite.svg" alt="Add to Wishlist" class="is-block"></a>
							</div>
						</div>
					</div>

					<div class="container is-fluid">
						<div class="columns justify-content-center">
							<div class="column is-10">
           
                <detail v-if="productDetail.product" :product="{
                  images: productDetail.product.product_images,
                  featuredImage: productDetail.product.image,
                  name: productDetail.product.name,
                  brandName: productDetail.product.brand.name,
                  desc: productDetail.product.description,
                }"></detail>

                <features v-if="productDetail.product" :product="{
                  product_thc_cbd_levels: productDetail.product.product_thc_cbd_levels,
                  product_cannabis_attributes: productDetail.product.product_cannabis_attributes
                }"></features>

								<div class="product-info-blocks accordions">
									<terpene-profile 
                    v-if="productDetail.product" 
                    :terpenes="productDetail.product.terpenes.length > 0 ? productDetail.product.terpenes : []">
                  </terpene-profile>
                  <consumption 
                    v-if="productDetail.product"  
                    :product="{
                      usage_instructions: productDetail.product.usage_instructions
                    }">
                  </consumption>
                  <rating 
                    v-if="productDetail.product"  
                    :product="{
                      master_pid: productDetail.product_id
                    }">
                  </rating>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="column is-3-widescreen is-3-desktop is-5-tablet is-12-mobile store-details-wrapper pb0">
          <div class="store-details-block is-flex is-flex-column justify-content-between" v-if="productDetail.product">
            <div class="store-details-top ph15 pt15">
              <p v-if="isEmptyObj(selectedStore) == true">Please select store to add product in cart.</p>
              <div class="title store-title mb5" v-if="isEmptyObj(selectedStore) == false">Selected Store</div>
              <div class="store-availability is-flex justify-content-between mb20">
                <p>Product Available at {{ productDetail.product.location_products.length }} Stores</p>
                <a href="#" @click.prevent="changeStore()" class="has-underline"> {{ isEmptyObj(selectedStore) == false ? 'Change Store' : 'Select Store' }}</a>
              </div>
              
              <div class="store-item is-shadowless is-radiusless p0 bg-transparent mb80" v-if="isEmptyObj(selectedStore) == false">
                <div class="store-logo"  v-if="selectedStore">
                  <img v-if="selectedStore.image_url" :src="selectedStore.image_url" :alt="selectedStore.display_name">
                </div>
                <div class="store-detail" v-if="selectedStore">
                  <div class="store-name has-text-weight-semibold is-uppercase">
                    <p>{{ selectedStore.display_name ? selectedStore.display_name : selectedStore.name }}</p>
                  </div>
                  <div class="store-address mb5">
                    <p>{{ selectedStore.address_line_1 ? selectedStore.address_line_1 + ', ' + selectedStore.city : selectedStore.address_line_2 }}</p>
                    <p>(Closest to you)</p>
                  </div>
                </div>
              </div>

              <div class="product-attr mb30">
                <div class="title attr-title">Select Weight & Price</div>
              
                <div class="columns is-flex-mobile" v-if="productDetail.product">
                  <div class="column is-4 relative" v-bind:key="'variant_' + index" v-for="(variant, index) in locationProductDetail.location_product_variants">
                    <a v-if="!variant.available" href="#" class="outof-stock-overlay"  @click.prevent="showOutOfStockNotification()"></a>
                    <div :class="variant.available ? 'control variant-block has-text-centered mb10' : 'control is-out-of-stock variant-block has-text-centered mb10'">
                      <input class="is-checkradio is-block" :id="'product-variant-' + index" type="radio"
                        name="product-variant" v-model="selectedVariant" :value="variant">
                      <label :for="'product-variant-' + index"
                        class="is-flex is-flex-column align-items-center justify-content-center">
                        <div class="variant-item-block has-text-centered">
                          <div class="variant-weight has-text-weight-semibold">{{ variant.product_variant.weight_equivalent_dry_cannabis }}g</div>
                          <div class="variant-price">${{ variant.price }}</div>
                        </div>
                      </label>
                      <div class="variant-unit-price has-text-centered"><span
                          class="price">${{ (variant.price/variant.product_variant.weight_equivalent_dry_cannabis).toFixed(2) }}</span> / <span class="weight">g</span></div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="product-quantity" v-if="isEmptyObj(selectedStore) == false && productAvailableOnStore">
                <div class="title quantity-title">Select Quantity</div>
                <div class="quantity-block is-flex justify-content-between">
                  <button @click="decreaseQty()" class="button minus is-borderless " value="-"><img
                      src="@/assets/img/icon-minus.svg" alt="Decrease Quantity"></button>
                  <div class="field mb0">
                    <div class="control">
                      <!-- <input v-model="qty" class="input pointer-none is-shadowless has-text-centered" type="number" value="1"
                        min="0"> -->
                      <span v-text="qty" class="display-qty"></span>
                    </div>
                  </div>
                  <button @click="increaseQty()" class="button plus is-borderless " value="+"><img
                      src="@/assets/img/icon-plus.svg" alt="Increase Quantity"></button>
                </div>
              </div>
            </div>

            <div class="store-details-bottom" v-if="isEmptyObj(selectedStore) == false">
              <a
                @click.prevent="addToCart()"
                v-if="productAvailableOnStore"
                class="button is-flex justify-content-between is-primary add-to-cart-btn has-text-semibold-18">
                <span class="add-to-cart">Add to Cart</span>
                <span class="price" v-if="selectedVariant.price">${{ (selectedVariant.price * qty).toFixed(1)}}</span>
              </a>
              <a
                v-else
                class="button is-flex justify-content-between is-warning add-to-cart-btn has-text-semibold-18">
                <span class="add-to-cart">Product is unavailable at this store.</span>
              </a>
            </div>
          </div>
				</div>
			</div>
		</main>
    <app-footer></app-footer>

    <!-- modals -->
    <change-store-notice></change-store-notice>
    <select-store></select-store>
    <out-of-stock></out-of-stock>
	</div>
</div>
</template>
<script>
// NOT IN USE
import Detail from '@/Components/Pages/PageComponents/ProductDetail/Detail';
import Features from '@/Components/Pages/PageComponents/ProductDetail/Features';
import SelectedStore from '@/Components/Pages/PageComponents/ProductDetail/SelectedStore';
import TerpeneProfile from '@/Components/Pages/PageComponents/ProductDetail/Profile';
import Consumption from '@/Components/Pages/PageComponents/ProductDetail/Consumption';
import Rating from '@/Components/Pages/PageComponents/ProductDetail/Rating';

/**
 * Popups
 */
import ChangeStoreNotice from '@/Components/Pages/PageComponents/ProductDetail/ChangeStoreNotice';
import SelectStore from '@/Components/Pages/PageComponents/ProductDetail/SelectStore';
import OutOfStock from '@/Components/Pages/PageComponents/ProductDetail/OutOfStock';


import Env from '@/env';
import { mapGetters, mapActions } from "vuex";
import { indexOf, find, isEmpty } from 'lodash';

export default {
 components: {
    Detail,
    Features,
    TerpeneProfile,
    Consumption,
    Rating,
    SelectedStore,
    ChangeStoreNotice,
    SelectStore,
    OutOfStock,
  },
  name: 'FavProductDetail',
  data() {
    return {
      productAvailableOnStore: true,
      productDetail: {},
      qty: 1,
      selectedVariant: {
      },
      locationProductDetail: [],
    };
  },

  mounted() {
    let productObj = _.find(this.favProducts, { id: parseInt(this.$route.params.id) });
    if(productObj == undefined) {
       this.snackbar({
        type: "warning",
        message: "Sorry product doesnot exist."
      });
      this.goBack()
    } else {
      this.productDetail = productObj;
      this.validateProductAvailabilityOnStore();
    }
  },
  

  computed: {
    ...mapGetters({
      favProducts: "favouriteproducts/list",
      cartItems: "cart/cartItems",
      selectedStore: "lcoation/selected"
    }),

    cartProductIds() {
      let cartPids = [];
      this.cartItems.map(item => {
        cartPids.push(item.pid);
      })
      return cartPids;
    },

    weightOnCart() {
      let weight = 0.00;
      this.cartItems.map(item => {
        let totalItemWeight = parseFloat(item.qty) * parseFloat(item.weight_in_gm);
        weight = parseFloat(weight) + parseFloat(totalItemWeight);
      })
      return weight.toFixed(2);
    },

    isFavProduct() {
      const self = this;
      if(this.favProducts.length > 0){
        let idOnFavList = _.find(this.favProducts, function(o) { return o.id == self.$route.params.id });
        if(!_.isEmpty(idOnFavList)){
          return true;
        }
      }
      return false;
    },
  },

  watch: {
    selectedStore(store) {
      // When store is chnage check whether this product is available on this store or not
      this.validateProductAvailabilityOnStore();
    },
  },

  methods: {
    /**
     * Validate product on selected store
     */

    validateProductAvailabilityOnStore() {
      if(_.isEmpty(this.selectedStore)){
        this.productAvailableOnStore = false;
         this.snackbar({
          type: 'warning', 
          message:'Please select the store.',
          time: 3000,
        });
        return false;
      }
      let selectedStoreId = this.selectedStore.id;
      let locationProduct = this.productDetail.product.location_products;
      let selectedLocationProductVariant = _.find(locationProduct, {location_id : selectedStoreId});
      if(selectedLocationProductVariant != undefined) {
        this.locationProductDetail = selectedLocationProductVariant;
        this.productAvailableOnStore = true;
        if(this.locationProductDetail.location_product_variants.length > 0){
          this.selectedVariant = this.locationProductDetail.location_product_variants[0];
        }
      } else {
        this.productAvailableOnStore = false;
        this.snackbar({
          type: 'warning', 
          message: this.productDetail.product.name + ' is not available at ' + this.selectedStore.display_name,
          time: 5000,
        });
      }
    },

    /**
     * Check empty
     */
    isEmptyObj(obj) {
      for(var prop in obj) {
        if(obj.hasOwnProperty(prop))
          return false;
      }
      return true;
    },
    /**
     * Increase qty
     */
    increaseQty() {
      this.qty = this.qty + 1;
    },
    /**
     * Decrease qty
     */
    decreaseQty() {
      if(this.qty > 1){
        this.qty = this.qty - 1;
      }
    },

    changeStore() {
      bus.$emit('show-modal-change-store-notice', true);
    },

    showOutOfStockNotification() {
      bus.$emit('show-modal-out-of-stock', {
        modal: true,
        product: this.productDetail.product,
      });
    },

    goBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push({ name: 'HomePage' });
    },

     /**
     * Add item on cart
     * 
     */
    addToCart() {
      if( _.isEmpty(this.selectedVariant) ) {
        this.snackbar({
          type: 'warning', 
          message: 'Please Select Weight & Price.',
        });
        return false;
      }
      // If already exceed limit
      if(this.weightOnCart > 30.00){
        bus.$emit('show-modal-cart-limit-exceed', {
          overWeight: this.weightOnCart,
          modal: true,
        });
        return false;
      }
      
      // If going to exceed limit on adding this item
      let currentProductWeight = this.qty * this.selectedVariant.product_variant.weight_equivalent_dry_cannabis;
      let finalWeight = parseFloat(currentProductWeight) + parseFloat(this.weightOnCart);
      if(finalWeight > 30.00) {
        bus.$emit('show-modal-cart-limit-exceed', {
          overWeight: finalWeight,
          modal: true,
        });
        return false;
      }

       // Check the cart items has location_product_id and selected_variant_id then its update // else add 
      let filteredObj = _.find(this.cartItems, { location_product_id: parseInt(this.locationProductDetail.id),  selected_variant_id: parseInt(this.selectedVariant.id) })
      if(filteredObj == undefined) {
        // Add
        this.addCartItem({
          qty: this.qty,
          name: this.productDetail.product.name ? this.productDetail.product.name : this.locationProductDetail.name,
          image: this.productDetail.product.image,
          brand: this.productDetail.product.brand,
          product_id: this.productDetail.product_id, // done
          location_product_id: this.locationProductDetail.id,
          rate: this.selectedVariant.price,
          weight_in_gm: this.selectedVariant.product_variant.weight_equivalent_dry_cannabis,
          price: this.qty * this.selectedVariant.price,
          item: this.productDetail,
          variant: this.selectedVariant,
          selected_variant_id: this.selectedVariant.id,
        });
        this.snackbar({
          type: 'success', 
          message: 'Successfully added to cart.',
        });
      } else {
        this.updateCartItem({
          qty: this.qty,
          location_product_id: this.locationProductDetail.id,
          selected_variant_id: this.selectedVariant.id,
        });
        this.snackbar({
          type: 'success', 
          message: 'Successfully updated to cart.',
        });
      }
    },

     /**
    * Toggel fav product 
    */
    favouriteProduct() {

      if(!this.$store.getters.getLoggedInUserToken){
        this.snackbar({
          type: 'warning', 
          message: 'Please login to favourate product.',
        });
        return false;
      }

      // 0 pid mean no data 
      if(this.$route.params.id > 0) {
        // const url = `${Env.loginUrl}/api/v1/users/favourite/product`;
        this.spinner(true);
        const userId = this.$store.getters.getLoggedInUserId;
        const url = `${Env.productUrl}/api/v1/users/favourite`;
        this.postApi(url, {
          "app-id": Env.productAppId,
          "app-secret": Env.productAppSecret
        }, {
          user_id: userId,
          product: this.productDetail.product_id.toString(),
        })
        .then( res => {
          this.setFavproduct(res.data.payload);
          this.snackbar({
            type: 'success', 
            message: res.data.msg ?  res.data.msg :'Successfully added to favourite.',
          });
          this.spinner(false);
        })
        .catch(() => {
          this.snackbar({
            type: 'warning', 
            message: 'Unable to favourite product. Please try again later.',
          });
          this.spinner(false);
        })
      } 
    },

    /**
     * Unfavourite product
     */
    unFavouriteProduct() {
      if(!this.$store.getters.getLoggedInUserToken){
        this.snackbar({
          type: 'warning', 
          message: 'Please login to favourate product.',
        });
        return false;
      }
      // 0 pid mean no data 
      if(this.$route.params.id > 0) {
        this.spinner(true);
        const userId = this.$store.getters.getLoggedInUserId;
        const url = `${Env.productUrl}/api/v1/users/favourite`;
        this.deleteApi(url, {
          "app-id": Env.productAppId,
          "app-secret": Env.productAppSecret
        }, {
          user_id: userId,
          product: this.productDetail.product_id.toString(),
        })
        .then( res => {
          this.setFavproduct(res.data.payload);
          this.snackbar({
            type: 'success', 
            message: res.data.msg ?  res.data.msg : 'Successfully unfavourite product.',
          });
          this.spinner(false);
        })
        .catch(() => {
          this.spinner(false);
          this.snackbar({
            type: 'warning', 
            message: 'Unable unfavourite product.Please try again later',
          });
        })
      } 
    },

    ...mapActions({
      spinner: "spinner/setSpinner",
      snackbar: "snackbar/setSnackbar",
      setFavproduct: 'favouriteproducts/setList',
      addCartItem: 'cart/addCartItem',
      updateCartItem: 'cart/updateCartItem',
    })
  },
};
</script>

<style scoped>

.product-img-wrapper {
    width: 250px;
}

.is-out-of-stock {
    pointer-events: none;
}
.relative{
  position: relative;
}
.outof-stock-overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
}
.button.is-warning,.button.is-warning :hover {
    background-color: #f4716e;
    border-color: transparent;
    color: #fff;
    pointer-events: none;
}
</style>